{
	"title": "Transazione non trovata",
	"description": "Vai alla panoramica e inserisci un ID transazione valido. Un ID transazione può essere trovato su una dichiarazione o su una fattura.",
	"secondaryButtonTitle": "Mostra la pagina iniziale"
}
